"use strict";
var zip_1 = require('./zip');
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
function zipAll(project) {
    return this.lift(new zip_1.ZipOperator(project));
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/operator/zipAll.js
 ** module id = 344
 ** module chunks = 2
 **/